import { getRouteApi } from '@tanstack/react-router';

import { keys } from '@vestigas/utils';
import { getDatesForPredefinedDateRange } from '~/utils/filters';

import { DATE_RANGE_OPTIONS, DateRangeNameOption } from '../constants';

/**
 * Returns actual from and to dates for the given date range name.
 * @param dateRangeName - The name of the date range.
 * @returns The date range date values.
 */
export function getDatesForDateRangeName(dateRangeName: DateRangeNameOption) {
  if (!keys(DATE_RANGE_OPTIONS).includes(dateRangeName)) {
    return undefined;
  }

  const [dateFrom, dateTo] = getDatesForPredefinedDateRange(
    dateRangeName,
    'string',
  );

  if (!dateFrom || !dateTo) {
    return undefined;
  }

  const dateRange = {
    dateFrom,
    dateTo,
  };

  return dateRange;
}

/**
 * Returns the selected date range with the actual from and to dates.
 * @returns The date range date values.
 */
export function useDateRange() {
  const AnalyticsUsageRoute = getRouteApi('/(main)/analytics/usage/');

  const dateRangeName = AnalyticsUsageRoute.useSearch({
    select: ({ dateRangeName }) => dateRangeName,
  });

  return getDatesForDateRangeName(dateRangeName);
}
